import { isValidWord } from 'app/validators/validateWord';
import { LabelEnum } from 'app/shared/enums';

export default function validateWord(value: string) {
  return isValidWord(value) ? undefined : LabelEnum.InvalidChar;
}
